import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AddIconWhite } from "../../assets/images";
import {
  ChangeUserStatusType,
  GetAllFinacUserPayloadType,
} from "../../commonTypes/authTypes";
import ExternalUser from "../../components/AllUserAndClients/ExternalUser";
import InternalUser from "../../components/AllUserAndClients/InternalUser";
import { CommonHeader } from "../../components/commons";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import {
  resetAuthError,
  resetAuthSuccess,
  resetClientList,
  resetFinacUsersList,
  resetSession,
  resetTotalUserCount,
  resetUserProfileAllData,
} from "../../redux/auth";
import {
  changeUserStatusAction,
  getAllFinacClientsAction,
  getAllFinacUsersAction,
} from "../../redux/auth/actions";
import { ClientType, LoginResponseType } from "../../redux/auth/authTypes";
import { getClientDirectoryListAction } from "../../redux/clientDirectory";
import { RootState } from "../../redux/rootReducers";
interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
const tabs: TabsType[] = [
  {
    name: "Internal Users",
    label: "Internal Users",
    display: false,
  },
  {
    name: "External Users",
    label: "External Users",
    display: false,
  },
];

export type UserStatusDataType = {
  name: string;
  user_id: number | null;
  is_active: number | null;
  type: "External Users" | "Internal Users" | null;
};

type AppProps = {
  fetching: boolean;
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetError: () => void;
  dispatchResetAuthSuccess: () => void;
  clientDetails: ClientType[] | [];
  dispatchChangeUserStatusAction: (data: ChangeUserStatusType) => void;
  dispatchResetSession: () => void;
  dispatchGetAllClientsAction: (data: any) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  loginData: LoginResponseType;
  history: any;
  dispatchResetUserProfileAllData: () => void;
  dispatchResetUserDetails: () => void;
  dispatchResetClientDetails: () => void;
  dispatchResetTotalUserCount: () => void;
  // dispatchResetTotalClientsCount: () => void;
  totalUserCount: string | number;
  totalClientsCount: null | number;
  allFinacUsersList: any;
};

const User = ({
  fetching,
  success,
  statusCode,
  token,
  error,
  dispatchResetError,
  dispatchResetAuthSuccess,
  dispatchChangeUserStatusAction,
  dispatchResetSession,
  loginData,
  history,
  dispatchResetUserProfileAllData,
  dispatchResetUserDetails,
  dispatchResetClientDetails,
  dispatchGetAllClientsAction,
  clientDetails,
  dispatchGetAllFinacUsersAction,
  allFinacUsersList,
  totalClientsCount,
  dispatchResetTotalUserCount,
}: // dispatchResetTotalClientsCount,
AppProps) => {
  // const userDetails=allFinacUsersList?.data;
  // const totalUserCount=allFinacUsersList?.total_count;

  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [activeComponent, setActiveComponent] = useState<any>();
  const [isAddInternalPresent, setIsAddInternalPresent] = useMenuCheck();
  const [isAddExternalPresent, setIsAddExternalPresent] = useMenuCheck();
  const [isInternalListPresent, setIsInternalListPresent] =
    useMenuCheck("initializeAsFalse");
  const [isExternalListPresent, setIsExternalListPresent] =
    useMenuCheck("initializeAsFalse");

  let persistActiveTab = history?.location?.state?.tabs;

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    history.push({
      pathName: "/all-users",
      state: { tabs },
    });
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setIsAddInternalPresent("Add Internal Users", "menu");
    setIsAddExternalPresent("Add External Users", "menu");
    setIsInternalListPresent("Internal Users List", "menu");
    setIsExternalListPresent("External Users List", "menu");
  }, []);

  useEffect(() => {
    if (isInternalListPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "Internal Users") {
          return (e.display = true);
        }
      });
    }

    if (isInternalListPresent === false && isExternalListPresent) {
      setActiveComponent(<ExternalUser history={history} />);
      setActiveTab("External Users");
      tabs?.forEach((e: any) => {
        if (e.label === "Internal Users") {
          return (e.display = false);
        }
      });
    }

    if (isExternalListPresent === true) {
      tabs?.forEach((e: any) => {
        if (e.label === "External Users") {
          return (e.display = true);
        }
      });
    }
    if (isExternalListPresent === false) {
      tabs?.forEach((e: any) => {
        if (e.label === "External Users") {
          return (e.display = false);
        }
      });
    }
  }, [isInternalListPresent, isExternalListPresent]);

  useEffect(() => {
    if (!!persistActiveTab) {
      setActiveTab(persistActiveTab);
    }
  }, [persistActiveTab]);

  useEffect(() => {
    let locationTab =
      history &&
      history?.location &&
      history?.location?.state &&
      history?.location?.state
        ? history?.location?.state?.tabs
        : 0;
    if (locationTab) {
      if (locationTab === "External Users" && isExternalListPresent) {
        setActiveTab(locationTab);
        setActiveComponent(<ExternalUser history={history} />);
      } else if (isInternalListPresent) {
        setActiveComponent(<InternalUser history={history} />);
      }
    } else {
      if (activeTab === "Internal Users" && isInternalListPresent) {
        setActiveComponent(<InternalUser history={history} />);
      } else if (activeTab === "External Users" && isExternalListPresent) {
        setActiveComponent(<ExternalUser history={history} />);
      }
    }
  }, [activeTab, isInternalListPresent, isExternalListPresent]);

  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  // let component = <InternalUser
  //  history={history}/>

  // if (activeTab === 'Internal Users') {
  //     component =<InternalUser
  //  history={history}/>

  // }
  // else if (activeTab === 'External Users') {
  //     component = <ExternalUser
  //     history={history}/>

  // }

  return (
    <>
      {/* <CommonHeader title={`All Users & Clients`} /> */}
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonHeader title={`All Users`} />
        </div>
      </div>
      {/* <div className="tab-container d-flex flex-row justify-content-start align-items-center">
                {renderTabs()}
            </div> */}
      <div className="col-md-12">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px 0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>

            <div className="">
              <div className="d-flex flex-row justify-content-end">
                {isAddInternalPresent && (
                  <button
                    style={{ fontSize: "13px" }}
                    className="btn btn-primary"
                    onClick={() =>
                      history.push({
                        pathname: `/all-users/add-internal-user`,
                        state: activeTab,
                      })
                    }
                  >
                    <img src={AddIconWhite} alt="add_icon" />
                    <span>Add Internal User</span>
                  </button>
                )}
                {isAddExternalPresent && (
                  <button
                    style={{ fontSize: "13px" }}
                    className="btn btn-secondary ml-4"
                    onClick={() =>
                      history.push({
                        pathname: `/all-users/add-external-user`,
                        state: activeTab,
                      })
                    }
                  >
                    <img src={AddIconWhite} alt="add_icon" />
                    <span> Add External User</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div
          className="new-table-card"
          style={{ borderRadius: "0 0 4px 4px", padding: "20px 0px 0px 0px" }}
        >
          {activeComponent}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.auth.fetching,
  success: state.auth.success,
  error: state.auth.error,
  userDetails: state.auth.userDetails,
  statusCode: state.auth.statusCode,
  token: state.auth.token,
  loginData: state.auth.loginData,
  totalUserCount: state.auth.totalUserCount,
  clientDetails: state.auth.clientList,
  totalClientsCount: state.auth.totalClientsCount,
  allFinacUsersList: state.auth.finacUsersList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchChangeUserStatusAction: (data: ChangeUserStatusType) =>
    dispatch(changeUserStatusAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllFinacClientsAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacClientsAction(data)),
  dispatchGetAllClientsAction: (data: any) =>
    dispatch(getClientDirectoryListAction(data)),
  dispatchResetUserProfileAllData: () => dispatch(resetUserProfileAllData()),
  dispatchResetTotalUserCount: () => dispatch(resetTotalUserCount()),
  // dispatchResetTotalClientsCount: () => dispatch(resetTotalClientsCount()),
  dispatchResetUserDetails: () => dispatch(resetFinacUsersList()),
  dispatchResetClientDetails: () => dispatch(resetClientList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
